var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { Dot } from './CarouselStyles';
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var Dots = function (_a) {
    var number = _a.number, currentSlide = _a.currentSlide, instanceRef = _a.instanceRef;
    return (React.createElement("div", { className: "dots-container" }, __spreadArray([], Array.from(Array(number).keys()), true).map(function (idx) {
        return (React.createElement(Dot, { sx: __assign({}, (currentSlide === idx && {
                '&:after': {
                    opacity: 1,
                    backgroundColor: designTokens.color.gray.slateDefault.value,
                },
                cursor: 'default',
            })), key: idx, onClick: function () {
                var _a;
                (_a = instanceRef.current) === null || _a === void 0 ? void 0 : _a.moveToIdx(idx);
            } }));
    })));
};
export default Dots;
//# sourceMappingURL=Dots.js.map